import { Route } from '@angular/router';
import { BaselinesTabTableComponent } from './components/tables/baselines-tab/baselines-tab-table.component';
import { ClearedChartComponent } from './components/tables/cleared-tab/chart/cleared-tab-chart.component';
import { ClearedContainerComponent } from './components/tables/cleared-tab/cleared-container.component';
import { ClearedTabTableComponent } from './components/tables/cleared-tab/table/cleared-tab-table.component';
import { DeclaredAvailabilityTabTableComponent } from './components/tables/da-tab/da-tab-table.component';
import { OpenGraphComponent } from './components/tables/open-tab/graph/open-graph.component';
import { OpenContainerComponent } from './components/tables/open-tab/open-container.component';
import { OpenTableComponent } from './components/tables/open-tab/table/open-table.component';
import { ScheduleTabTableComponent } from './components/tables/schedule-tab/schedule-tab-table.component';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    children: []
  },
  {
    path: 'open',
    component: OpenContainerComponent,
    children: [
      { path: 'table', component: OpenTableComponent },
      { path: 'chart', component: OpenGraphComponent }
    ]
  },
  {
    path: 'cleared',
    component: ClearedContainerComponent,
    children: [
      { path: 'table', component: ClearedTabTableComponent },
      { path: 'chart', component: ClearedChartComponent }
    ]
  },
  { path: 'schedule', component: ScheduleTabTableComponent },
  { path: 'baselines', component: BaselinesTabTableComponent },
  { path: 'da', component: DeclaredAvailabilityTabTableComponent },
  { path: 'endesa', component: OpenTableComponent },
  { path: 'agora', component: OpenTableComponent },
  { path: 'enelx', component: OpenTableComponent },
  { path: '**', children: [] }
];
